import type { ArtifactInput } from '@erikdakoda/artifact/ai-tools/artifacts';
import type { ArtifactEntry, ArtifactType } from '../hooks/useArtifactStore';
import { useArtifactStore } from '../hooks/useArtifactStore';

/**
 * Maps an artifacts tool input to a client artifact store entry.
 */
export function artifactInputToStoreEntry(input: ArtifactInput): ArtifactEntry {
  return {
    identifier: input.identifier,
    type: input.type as ArtifactType,
    title: input.title,
    content: input.content,
    display: input.display === 'inline' || input.display === 'panel' ? input.display : undefined,
  };
}

/**
 * Stable fingerprint of artifact tool inputs for deduping sync work across frequent message updates.
 */
export function buildArtifactInputsSyncKey(inputs: readonly ArtifactInput[]): string {
  return inputs
    .map((input) => `${input.identifier}\0${input.title}\0${input.type}\0${input.content}`)
    .join('\x1e');
}

/**
 * Upserts the latest artifact tool inputs into the client artifact store (latest per identifier wins).
 */
export function syncArtifactStoreFromMessageInputs(inputs: readonly ArtifactInput[]): void {
  const { upsertArtifact } = useArtifactStore.getState();
  for (const input of inputs) {
    upsertArtifact(artifactInputToStoreEntry(input));
  }
}
